import { Card, CardContent } from "@/components/ui/card";
import { Send, CalendarClock, XCircle, Trophy, ClipboardList } from "lucide-react";

const STATS = [
  { key: "in_progress", label: "In Progress", icon: ClipboardList, cls: "text-[#8a6410]", bg: "bg-[#E8A93C]/15" },
  { key: "applied", label: "Applied", icon: Send, cls: "text-blue-600", bg: "bg-blue-50" },
  { key: "interview", label: "Interview", icon: CalendarClock, cls: "text-amber-600", bg: "bg-amber-50" },
  { key: "offer", label: "Offer", icon: Trophy, cls: "text-green-600", bg: "bg-green-50" },
  { key: "rejected", label: "Rejected", icon: XCircle, cls: "text-red-600", bg: "bg-red-50" },
];

export function DashboardCards({ apps }) {
  const counts = apps.reduce((acc, a) => { acc[a.status] = (acc[a.status] || 0) + 1; return acc; }, {});
  return (
    <div className="grid grid-cols-2 lg:grid-cols-6 gap-4" data-testid="tracker-dashboard">
      <Card className="border-zinc-200 shadow-sm" data-testid="stat-total">
        <CardContent className="p-4">
          <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Total</p>
          <p className="font-heading text-3xl font-bold mt-1">{apps.length}</p>
        </CardContent>
      </Card>
      {STATS.map((s) => {
        const Icon = s.icon;
        return (
          <Card key={s.key} className="border-zinc-200 shadow-sm" data-testid={`stat-${s.key}`}>
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{s.label}</p>
                <div className={`h-7 w-7 rounded-md ${s.bg} flex items-center justify-center`}>
                  <Icon className={`h-4 w-4 ${s.cls}`} strokeWidth={1.75} />
                </div>
              </div>
              <p className="font-heading text-3xl font-bold mt-1">{counts[s.key] || 0}</p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
